import React, {Component, Fragment} from 'react';
import {Pagination, List} from 'semantic-ui-react';

export default class CollectionsTabPane extends Component {

    constructor(props) {
        super(props);

        const collections = props.collections || [];

        this.state = {
            activePage: 1,
            totalPages: Math.ceil(collections.length / 10),
            collections: collections,
            pagedCollections: collections.slice(0, 10),
        };
    }

    onPageChange(e, data) {
        const offset = (data.activePage - 1) * 10;

        this.setState({
            activePage: data.activePage,
            pagedCollections: this.state.collections.slice(offset, offset + 10),
        });
    };

    render() {
        const {pagedCollections, totalPages} = this.state;
        let pagination = null;

        if(totalPages > 1) {
            pagination = <Pagination totalPages={totalPages} onPageChange={this.onPageChange.bind(this)} defaultActivePage={1}/>
        }

        return (
            <Fragment>
                <List divided relaxed size='large'>
                {
                    pagedCollections.map(c => { return (
                        <List.Item key={c.Id}>
                            <List.Content>
                                <List.Header as='a'>{c.Name.English}</List.Header>
                                <List.Description>{`${c.Description ? c.Description.English: ''}`}</List.Description>
                            </List.Content>
                        </List.Item>
                    )})
                }
                </List>
                {pagination}
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/tabs/CollectionsTabPane.jsx